/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Headers/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import TysiaTextarea from 'DesignSystem/TysiaTextarea/index'
import TysiaTextareaContent from 'DesignSystem/TysiaTextarea/TysiaTextareaContent/index'
import TysiaTextareaField from 'DesignSystem/TysiaTextarea/TysiaTextareaField/index'
import TysiaTextareaLabel from 'DesignSystem/TysiaTextarea/TysiaTextareaLabel/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Headers({
  children,
  viewPath = "/DesignSystem/ApiCaller/Response/Content/Content/Response/Headers"
  
}) {
let responseHeadersValueData = fromData.useDataFormat({ viewPath,
context: 'response',
path: 'headers',
format: fromHelpers.prettify,
})
let responseStatusValueData = fromData.useDataValue({ viewPath,
context: 'response',
path: 'status',
})
let constantData = ' - '
let responseStatusTextValueData = fromData.useDataValue({ viewPath,
context: 'response',
path: 'statusText',
})
let aggregateData = fromAggregate.join(responseStatusValueData, constantData, responseStatusTextValueData)
  return (<React.Fragment
>
<TysiaTextarea
  viewPath={`${viewPath}/TysiaTextarea`}
 height="50px"
 disabled={true}
 data="response.headers"
 format="helpers.js prettify"
 size="small"
 value={responseHeadersValueData}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Headers.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaTextareaLabel
  viewPath={`${viewPath}/TysiaTextareaLabel`}
 text="Headers"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="response.status"
 data="' - '"
 data="response.statusText"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
</div>
<TysiaTextareaContent
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaContent`}
>
{childProps => (
<TysiaTextareaField
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaField`}
/>
)}
</TysiaTextareaContent>
</React.Fragment>
)}
</TysiaTextarea>
{children}
</React.Fragment>)
}